import type { ModuleCode } from '../../features/modules/modules';
import apiClient from '../index';

export const getFileGroupsForClient = async (
	clientId: string,
	module: ModuleCode,
) => {
	const response = await apiClient.get(
		`/clients/${clientId}/file-groups?${new URLSearchParams({ module })}`,
	);
	return response.data;
};

export const getFileGroup = async (groupId: string) => {
	const response = await apiClient.get(`/file-groups/${groupId}`);
	return response.data;
};

export const createFileGroup = async (
	clientId: string,
	name: string,
	module: ModuleCode,
) => {
	const response = await apiClient.post(`/clients/${clientId}/file-groups`, {
		name,
		module,
	});
	return response.data;
};

export const renameFileGroup = async (groupId: string, name: string) => {
	const response = await apiClient.patch(`/file-groups/${groupId}`, { name });
	return response.data;
};

export const deleteFileGroup = async (groupId: string) => {
	const response = await apiClient.delete(`/file-groups/${groupId}`);
	return response.data;
};

export const setFileGroupFiles = async (groupId: string, fileIds: string[]) => {
	const response = await apiClient.put(`/file-groups/${groupId}/files`, {
		fileIds,
	});
	return response.data;
};
